import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ValidatorsHelper } from '../../../helpers/validators.helper';
import { IChangePasswordRequest } from '../../../interfaces/change-password-request.interface';
import { BaseComponent } from '../../base.component';
@UntilDestroy()
@Component({
    selector: 'aumico-users-edit-security-component',
    templateUrl: 'security.component.html',
    styleUrls: ['security.component.scss'],
})
export class EditUserSecurityComponent extends BaseComponent {
    changePasswordFormGroup: UntypedFormGroup;
    passwordChange: string;
    showPasswordConstraints = false;
    public passwordValidatorRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s+]).{8,}$/);

    @Output() changeInPassword = new EventEmitter<IChangePasswordRequest>();

    constructor(private readonly formBuilder: UntypedFormBuilder) {
        super();
        this.changePasswordFormGroup = this.formBuilder.group(
            {
                oldPassword: new UntypedFormControl('', [Validators.required]),
                newPassword: new UntypedFormControl('', [
                    Validators.required,
                    ValidatorsHelper.checkPasswordStrength(),
                ]),
                confirmNewPassword: new UntypedFormControl('', [Validators.required]),
            },
            { validators: this.checkPasswords },
        );

        this.changePasswordFormGroup
            .get('newPassword')
            .valueChanges.pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.passwordChange = value;
                this.showPasswordConstraints = true;
            });
    }

    onChangePassword(): void {
        if (this.changePasswordFormGroup.valid) {
            const changePasswordForm: IChangePasswordRequest = {
                oldPassword: this.changePasswordFormGroup.get('oldPassword').value,
                newPassword: this.changePasswordFormGroup.get('newPassword').value,
            };
            this.changeInPassword.emit(changePasswordForm);
        }
    }

    checkPasswords(group: UntypedFormGroup) {
        const password = group.get('newPassword').value;
        const confirmPassword = group.get('confirmNewPassword').value;
        if (password === confirmPassword && password.trim() !== '') {
            return null;
        } else {
            return { notSame: true };
        }
    }
}
